import React from 'react';
import './App.css';
import BiscuitMachine from './components/biscuit-machine';

function App() {
  return (
    <div className="App">
      <BiscuitMachine />
    </div>
  );
}

export default App;
